export default __webpack_public_path__ + "static/media/bloggerly-black.e82e1ea9.svg";